export interface AnnouncementPayload {
  id: string;
  title: string;
  body: string;
  cta?: string;
  ctaRoute?: string;
  icon?: string;
}

export function isValidAnnouncementPayload(value: unknown): value is AnnouncementPayload {
  if (!value || typeof value !== 'object') return false;
  const obj = value as Record<string, unknown>;
  return typeof obj.id === 'string' && typeof obj.title === 'string' && typeof obj.body === 'string';
}
